import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { ExamResultsResponse } from "@/lib/api";

export interface Attempt {
  id: string;
  date: number;
  examId: string;
  title: string;
  totalCorrect: number;
  totalQuestions: number;
  overallPercent: number;
  estimatedLow: number;
  estimatedHigh: number;
  sectionScores: { section_id: string; label: string; correct: number; total: number; percent: number }[];
  weakTopics: string[];
  strengths: string[];
  totalSeconds: number;
}

interface AttemptsState {
  attempts: Attempt[];
  record: (r: ExamResultsResponse) => void;
  clear: () => void;
}

export const useAttempts = create<AttemptsState>()(
  persist(
    (set) => ({
      attempts: [],
      record: (r) =>
        set((s) => ({
          attempts: [
            {
              id: `${r.session_id}-${Date.now()}`,
              date: Date.now(),
              examId: r.exam_id,
              title: r.title,
              totalCorrect: r.total_correct,
              totalQuestions: r.total_questions,
              overallPercent: r.overall_percent,
              estimatedLow: r.estimated_score_range[0],
              estimatedHigh: r.estimated_score_range[1],
              sectionScores: r.section_scores,
              weakTopics: r.weak_topics,
              strengths: r.strengths ?? [],
              totalSeconds: r.timing?.total_seconds ?? 0,
            },
            ...s.attempts,
          ].slice(0, 100),
        })),
      clear: () => set({ attempts: [] }),
    }),
    { name: "gslm-attempts" },
  ),
);
